/* ============================================
   ENGLISH TRANSLATIONS
   ============================================ */

export const en = {
  // Match states
  matchStates: {
    notStarted: 'Not started',
    firstHalf: '1st half',
    halfTime: 'Half time',
    secondHalf: '2nd half',
    extraTimeFirstHalf: 'Extra time',
    extraTimeHalfTime: 'Break',
    extraTimeSecondHalf: 'Extra time',
    penalties: 'Penalties',
    finished: 'Finished',
    postponed: 'Postponed',
    cancelled: 'Cancelled',
    interrupted: 'Interrupted',
  },

  // Events
  events: {
    goal: 'Goal',
    yellowCard: 'Yellow card',
    redCard: 'Red card',
    substitution: 'Substitution',
    corner: 'Corner',
    freeKick: 'Free kick',
    penalty: 'Penalty',
    offside: 'Offside',
    injury: 'Injury',
    var: 'VAR',
    shotOnTarget: 'Shot on target',
    shotOffTarget: 'Shot off target',
    throwin: 'Throw in',
    dangerousAttack: 'Dangerous attack',
    attack: 'Attack',
    possession: 'Possession',
    sixMeters: '6 yards box',
    goalKick: 'Goal kick',
    blockedShot: 'Blocked shot',
    penaltyUnconfirmed: 'Penalty (unconfirmed)',
    penaltyMissed: 'Penalty missed',
    goalNotification: 'Goal notification',
    kickoff: 'Kickoff',
    secondHalfKickoff: '2nd half kickoff',
    ballLost: 'Ball lost',
    ballRecovered: 'Ball recovered',
    ownGoal: 'Own goal',
    matchStart: 'Start',
    matchEnd: 'End',
    halfTimeScore: 'Half time score',
    cardConfirmed: 'Card confirmed',
    extraTimeEnded: 'Extra time ended',
    penaltyEnded: 'Penalty ended',
    penaltyShootout: 'Penalty shootout',
    penaltyShootoutMissed: 'Penalty shootout missed',
  },

  // Possession indicators
  possession: {
    home: 'Home possession',
    away: 'Away possession',
    attack: 'Attack',
    dangerousAttack: 'Dangerous attack',
  },

  // Interface
  ui: {
    home: 'Home',
    away: 'Away',
    connected: 'Connected',
    disconnected: 'Disconnected',
    connecting: 'Connecting...',
    loading: 'Loading...',
    noMatch: 'No match selected',
    selectMatch: 'Select a match',
  },

  // Added time
  addedTime: {
    label: 'Added time',
    minute: 'min',
    minutes: 'min',
  },

  // Notifications
  notifications: {
    matchStarted: 'Match start',
    matchEnded: 'Match ended',
    halfTimeStarted: 'Half time',
    secondHalfStarted: 'Second half started',
    matchAboutToStart: 'The match is about to start',
    matchAboutToResume: 'The match is about to resume',
    penaltiesInProgress: 'The shootout is in progress',
    // Centered event notifications
    kickoffTitle: 'Kickoff',
    kickoffSubtitle: 'The match is on!',
    goalTitle: 'Goal! goal! goal!',
    yellowCardTitle: 'Yellow card',
    yellowCardSubtitle: 'A player received a yellow card',
    redCardTitle: 'Red card',
    redCardSubtitle: 'A player received a red card',
    injuryTitle: 'Injury',
    injurySubtitle: 'A player is injured',
    substitutionTitle: 'Substitution',
    substitutionSubtitle: 'Change in progress',
    varTitle: 'VAR in progress',
    varSubtitle: 'The referee will make a decision',
    varCancelledTitle: 'Goal cancelled',
    varCancelledSubtitle: 'The goal was cancelled by VAR',
    addedTimeTitle: 'Added time',
    addedTimeSubtitle: 'Extra minutes will be played!',
  },

  // Field indicators (UPPERCASE)
  fieldIndicators: {
    possession: 'POSSESSION',
    attack: 'ATTACK',
    dangerousAttack: 'DANGEROUS ATTACK',
    throwin: 'THROW-IN',
    freeKick: 'FREE KICK',
    dangerousFreeKick: 'DANGEROUS FREE KICK',
    corner: 'CORNER',
    goalKick: 'GOAL KICK',
    penalty: 'PENALTY',
    shotOnTarget: 'SHOT ON TARGET',
    shotOffTarget: 'SHOT OFF TARGET',
    offside: 'OFFSIDE',
    ballLost: 'BALL LOST',
  },

  // Countdown
  countdown: {
    hours: 'H',
    minutes: 'MIN',
    seconds: 'SEC',
  },

  // Controls
  controls: {
    openRadar: 'Open Radar',
    reload: 'Reload',
    date: 'Date',
    match: 'Match',
    delay: 'Delay (seconds)',
    fieldLength: 'Length (px)',
    fieldWidth: 'Width (px)',
    fieldColor: 'Field color',
    language: 'Language',
    connectedStatus: 'Connected',
    disconnectedStatus: 'Disconnected',
  },
};

